// v.1.5.13
// @preserve Copyright (c) Lumedx, Inc.
// All Rights Reserved

// Load runtime environment variables from window.env if available, otherwise fallback to process.env
const env = (typeof window !== 'undefined' && window.env) ? window.env : process.env;

const powerBISettings = {
  tokenExpiredInSec: 3600,
  SupportDocumentButtonTitle: 'support documentation',
  FeatureDisplayText: 'Content Pack',
  SectionDisplayText: 'Content Pack Group',
  reportServiceUrl: env.REPORT_SERVICE_URL,
  tenantAdminServiceUrl: env.TENANT_ADMIN_SERVICE_URL,
  UIAppClientId: env.UI_APP_CLIENT_ID,
  serviceAppClientId: env.SERVICE_APP_CLIENT_ID,
  logoutredirectURL: env.LOGOUT_REDIRECT_URL,
  flareDocumentUrl: env.FLARE_DOCUMENT_URL,
  customQueryExecutorUrl: env.CUSTOM_QUERY_EXECUTOR_URL,
  accessTokenRefreshTimeDuration : Number(env.ACCESSTOKEN_REFRESH_TIME_DURATION) || 30, // in minutes
  sessionTimeoutMessage : Number(env.SESSION_TIMEOUT_MESSAGE) || 2, // in minutes


  CRUDOperations: {
    ADD: 'ADD',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    VIEW: 'VIEW'
  },
  PopupErrorState: {
    BtnCancelClicked: "Cancel"
  },
  CryptoVariables: {
    DecisionMaker: 'THVtM2R4QDIwMThIdkBuQGx5dGljc0Ns',
    Supporter: 'QEx1bWVkMXgxNUY2ZzdIOA=='
  },
  ReportNotificationViewTypes: [
    { id: "0", name: 'Select Report Notifications Type' },
    { id: "1", name: 'My Subscription(s)' },
    { id: "2", name: 'Subscription(s) (I am member of)' },
    { id: "3", name: 'Subscription Report' }
  ]
};

export default powerBISettings;

export const Values = {
  DefaultTimeout: 0,
  TimeoutId: undefined
};